// removed by extract-text-webpack-plugin
module.exports = {"itemView":"gridAudio-module_itemView_11GKV","itemName":"gridAudio-module_itemName_16nQO","actionContainer":"gridAudio-module_actionContainer_1g0Fx","footer":"gridAudio-module_footer_mrlFK","thumbnail":"gridAudio-module_thumbnail_zGLL3","miniAudioPlayerContainer":"gridAudio-module_miniAudioPlayerContainer_5Od3E"};


//////////////////
// WEBPACK FOOTER
// ./client/components/itemCard/gridAudio.module.css
// module id = 1019
// module chunks = 1